import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { CalendarBlank } from "@phosphor-icons/react";
import { api, resolveImg } from "../lib/api";
import { useContent } from "../context/ContentContext";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";

export const PostsPage = ({ type, overline, title, subtitle, emptyText }) => {
  const { settings, loaded } = useContent();
  const [posts, setPosts] = useState([]);
  const [postsLoaded, setPostsLoaded] = useState(false);

  const enabled = type === "events" ? settings.events_enabled : settings.news_enabled;

  useEffect(() => {
    api.get(`/${type}`).then((r) => setPosts(r.data)).catch(() => {}).finally(() => setPostsLoaded(true));
  }, [type]);

  if (!loaded) return <div className="min-h-screen" />;
  if (!enabled) return <Navigate to="/" replace />;

  return (
    <div data-testid={`${type}-page`}>
      <PageHero overline={overline} title={title} subtitle={subtitle} />
      <section className="bg-cream py-24 md:py-28 min-h-[40vh]">
        <div className="max-w-7xl mx-auto px-5 sm:px-8">
          {postsLoaded && posts.length === 0 && (
            <div className="text-center py-20">
              <CalendarBlank size={48} className="text-navy/30 mx-auto" />
              <p className="font-heading text-2xl text-navy/60 mt-4">{emptyText}</p>
            </div>
          )}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {posts.map((p, i) => (
              <Reveal key={p.id} delay={i * 0.08}>
                <article className="bg-white border border-navy/10 overflow-hidden h-full flex flex-col group">
                  {p.image && (
                    <div className="h-52 overflow-hidden">
                      <img src={resolveImg(p.image)} alt={p.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                    </div>
                  )}
                  <div className="p-7 flex flex-col flex-1">
                    <span className="text-xs uppercase tracking-[0.2em] text-gold font-semibold">{p.date}</span>
                    <h3 className="font-heading text-2xl text-navy font-medium mt-2">{p.title}</h3>
                    <p className="mt-3 text-navy/70 leading-relaxed text-sm whitespace-pre-line flex-1">{p.body}</p>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};
